export default "<app-navy-app></app-navy-app>"